<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Product Movement'"></Breadcrumbs>
      <ProductMovementReport />
    </div>
    <div class="col-md-12 home-tabs-body"></div>
  </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import ProductMovementReport from "@/components/reports/ProductMovementReport.vue";
export default {
  components: { Breadcrumbs, ProductMovementReport },
};
</script>